module.exports = __webpack_public_path__ + "components/app-promo/static/en/snow-forecast__app-screenshot--5-cc771991887cd0ceb21563ec3ebe4819.jpg";